function getQueryParam(param) {
  let urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
jQuery(document).ready(function () {
  if ($(".homeBanner .contentImage img").length > 0) {
    let lastScrollTop = 0;
    let scale = 1; // Initial scale

    $(window).on("scroll", function () {
      let st = $(this).scrollTop();
      let $img = $(".homeBanner .contentImage img");

      if (st > lastScrollTop) {
        // Scrolling down — decrease scale
        scale = Math.max(0.5, scale - 0.01); // Min scale = 0.5
      } else {
        if ($(this).scrollTop() == 0) {
          scale = 1;
        } else {
          scale = Math.min(1, scale + 0.01);
        }
        // Scrolling up — increase scale
      }

      $img.css("transform", `scale(${scale})`);
      lastScrollTop = st;
    });
  }

  if (jQuery(".productSlider").length > 0) {
    var productSlider = new Splide(".productSlider", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "30px",
      autoplay: true,
      interval: 5000,
      speed: 1500,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        550: {
          perPage: 1,
        },
      },
    });

    productSlider.mount();
  }
  if (jQuery(".reviewSlider").length > 0) {
    var reviewSlider = new Splide(".reviewSlider", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "30px",
      pagination: true,
      autoplay: true,
      arrows: false,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        550: {
          perPage: 1,
        },
      },
    });

    reviewSlider.mount();
  }
  if (jQuery(".ingredientSlider").length > 0) {
    var ingredientSlider = new Splide(".ingredientSlider", {
      type: "loop",
      perPage: 5,
      perMove: 1,
      gap: "20px",
      pagination: false,
      autoplay: false,
      arrows: true,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        1024: {
          perPage: 3,
        },
        750: {
          perPage: 3,
        },
        550: {
          perPage: 1,
        },
      },
    });

    ingredientSlider.mount();
  }

  // key information tab js
  let selectedTab = getQueryParam("tab"); // e.g., ingredients, how_to, etc.

  if (selectedTab) {
    const tabId = `#tab_nav_${selectedTab}`;
    const $tabContainer = $(tabId);

    if ($tabContainer.length > 0) {
      const $tab = $tabContainer.find("p");

      // Remove all active classes
      $(".tab p").removeClass("active");
      $(".tabsContent .content").removeClass("active");

      // Get data attributes
      const bg_img = $tab.attr("data-bg-img");
      const nav_color = $tab.attr("data-nav-color");

      // Set background and container styles
      if (bg_img) {
        $(".mainTabsContainer").css("background-image", `url("${bg_img}")`);
        $(".tabsInnerContainer").css({
          border: "none",
          "padding-bottom": "5rem",
        });
      } else {
        $(".tabsInnerContainer").css({
          "border-top": "2px solid #1D1E4D",
          "border-bottom": "2px solid #1D1E4D",
          "padding-bottom": "2rem",
        });
        $(".mainTabsContainer").css("background-image", "none");
      }

      // Update nav styles and activate tab
      $(".tab p").css("color", nav_color);
      $tab.addClass("active");

      const target = $tab.attr("data-id");
      $(target).addClass("active");
    }
  }

  // Tab click logic
  if (jQuery(".tab p").length > 0) {
    $(".tab p").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        return;
      }

      $(".tab p").removeClass("active");
      $(".tabsContent .content").removeClass("active");

      let bg_img = $(this).attr("data-bg-img");
      let nav_color = $(this).attr("data-nav-color");

      if (bg_img != "") {
        $(".mainTabsContainer").css("background-image", `url("${bg_img}")`);
        $(".tabsInnerContainer").css({
          border: "none",
          "padding-bottom": "5rem",
        });
      } else {
        $(".tabsInnerContainer").css({
          "border-top": "2px solid #1D1E4D",
          "border-bottom": "2px solid #1D1E4D",
          "padding-bottom": "2rem",
        });
        $(".mainTabsContainer").css("background-image", "none");
      }

      $(".tab p").css("color", nav_color);
      $(this).addClass("active");

      let target = $(this).attr("data-id");
      $(target).addClass("active");
    });
  }

  // register password eye js

  $("#create_customer svg.icon-eye, #create_customer svg.icon-hide-eye").on("click", function () {
    const $password = $("#RegisterForm-password");
    const $confirmPassword = $("#RegisterForm-confirm-password");
    const currentType = $password.attr("type");
    console.log(12)
    // Toggle the type
    const newType = currentType === "password" ? "text" : "password";
    $password.attr("type", newType);
    $confirmPassword.attr("type", newType);
  
    // Toggle icons
    const $iconEye = $(".icon-eye");
    const $iconHideEye = $(".icon-hide-eye");
  
    if (newType === "text") {
      $iconHideEye.hide();
      $iconEye.show();
    } else {
      $iconEye.hide();
      $iconHideEye.show();
    }
  });
  $("#customer_login svg.icon-eye, #customer_login svg.icon-hide-eye").on("click", function () {
    const $password = $("#CustomerPassword");
    
    const currentType = $password.attr("type");
    
    // Toggle the type
    const newType = currentType === "password" ? "text" : "password";
    $password.attr("type", newType);
  
    // Toggle icons
    const $iconEye = $(".icon-eye");
    const $iconHideEye = $(".icon-hide-eye");
  
    if (newType === "text") {
      $iconHideEye.hide();
      $iconEye.show();
    } else {
      $iconEye.hide();
      $iconHideEye.show();
    }
  });
  $("#create_customer").on("submit", function (e) {
    const password = $("#RegisterForm-password").val();
    const confirmPassword = $("#RegisterForm-confirm-password").val();

    if (password !== confirmPassword) {
      e.preventDefault(); // Stop form submit
      e.stopImmediatePropagation(); // Stop any other submit events
      $("#RegisterForm-password-matcher").css('display', 'flex'); // Show error
      return false; // Just in case, stop all flow
    } else {
      $("#RegisterForm-password-matcher").hide(); // Hide error if fixed
    }
  });
});
